module.exports = __webpack_public_path__ + "img/BuinZooLogo.d31557cf.svg";